declare const CDN_URL: string;

class ProberAnalytics {
  _areAdsSupported = async (): Promise<boolean> => {
    const adsURL =
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

    try {
      await fetch(adsURL, {
        method: 'HEAD',
        mode: 'no-cors',
      });
      return true;
    } catch (err) {
      return false;
    }
  };

  _are3pCookiesSupported = (): Promise<boolean> => {
    return new Promise((resolve) => {
      let supported: null | boolean = null;

      const frame = document.createElement('iframe');
      frame.id = '3pc';
      frame.src = `${CDN_URL}/check/index.html`;
      frame.style.display = 'none';
      frame.style.position = 'fixed';

      window.addEventListener(
        'message',
        function listen(event) {
          if (
            event.data === 'ag.3pc.supported' ||
            event.data === 'ag.3pc.unsupported'
          ) {
            supported = event.data === 'ag.3pc.supported';
            document.body.removeChild(frame);
            window.removeEventListener('message', listen);
            resolve(supported);
          }
        },
        false
      );

      setTimeout(() => {
        if (supported === null) {
          supported = false;
          document.body.removeChild(frame);
          resolve(supported);
        }
      }, 1e3);

      document.body.appendChild(frame);
    });
  };

  async get() {
    const are3pCookiesSupported = await this._are3pCookiesSupported();
    const areAdsSupported = await this._areAdsSupported();
    return { cs: are3pCookiesSupported, as: areAdsSupported };
  }
}

export const proberAnalytics = new ProberAnalytics();
